import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    ChartDataLabels
);


const BarChart = ({
    configData,
    data,
    horizontal,
    animation = true
}) => {
    const labels = configData?.map(detail => detail?.label);
    const backgroundColor = configData?.map(detail => detail?.color);

    const chartData = {
        labels,
        datasets: [
            {
                data: data?.map(val => Number(val) || 0),
                backgroundColor,
                borderRadius: 0,
                barThickness: 25,
            },
        ],
    };

    const options = {
        animation: animation === false ? false : {},
        indexAxis: horizontal ? "y" : "x",
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                right: 30,
                top: 20
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                anchor: "end",
                align: horizontal ? "right" : "top",
                color: "#555",
                font: {
                    weight: "600",
                },
                formatter: (value) => {
                    const number = Number(value);
                    return Number.isInteger(number) ? number : number?.toFixed(2);
                },
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                grid: {
                    color: "#F1F3F5",
                },
                ticks: {
                    color: "#888",
                    maxRotation: 0,
                    minRotation: 0,
                    autoSkip: false,
                },
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: "#444",
                    font: {
                        size: 12,
                        weight: "500",
                    },
                },
            },
        },
    };

    return (
        <div style={{ height: 200, width: "100%", overflow: "hidden" }}>
            <Bar key={labels?.join("-") || "empty"} data={chartData} options={options} />
        </div>
    );
};

export default BarChart;
